import { Address, MapPosition } from "../common";
import { AccountIntegration } from "../accountIntegration/types";
import { AccountBranch } from "../accountBranch/types";

/**
 * Entidad AccountDeliveryOption
 * Representa una opción de envío de una cuenta.
 */

export interface AccountDeliveryOption {
	id: string;
	accountId: string;
	accountBranchId: string;
	name: string;
	integrationId?: string;
	isScheduled: boolean;
	priceLogic: AccountDeliveryOptionPriceLogic;
	status: AccountDeliveryOptionStatus;
	demo:boolean;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date | null;

	zones: AccountDeliveryOptionZone[];
	integration?: AccountIntegration | null;
	calculatedCost?: AccountDeliveryOptionCalculatedCost | null;
	accountBranch?: AccountBranch | null;
}

export enum AccountDeliveryOptionPriceLogic {
	FIXED = "FIXED",
	PER_KM = "PER_KM",
}

export enum AccountDeliveryOptionStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

export interface AccountDeliveryOptionCalculatedCost {
	basePrice: number;
	distanceKm: number;
	finalPrice: number;
	priceLogic: AccountDeliveryOptionPriceLogic;
	currency: string;
}


export interface AccountDeliveryOptionZone {
	id: string;
	accountId: string;
	accountDeliveryOptionId: string;
	name: string;
	price: number;
	priceMin: number;
	area: string;
	status: AccountDeliveryOptionZoneStatus;
	demo:boolean;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date | null;
}

export enum AccountDeliveryOptionZoneStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}